export default __webpack_public_path__ + "static/media/docs.4741f917.svg";